import ToolRoutes from './tool.routes';

export default [
  ...ToolRoutes
]
